module.exports = __webpack_public_path__ + "img/meron.77270a3f.svg";